import { z } from "zod";

const ChannelValues = [
  "REMI_INTERNAL",
  "CONTRACTOR",
  "SOLAR_COMPANY",
  "CONTRACTOR_PRODUCTION_MESSAGES",
  "HOMEOWNER",
] as const;
const ChannelSchema = z.enum(ChannelValues);
export type Channel = (typeof ChannelValues)[number];
export const Channel = ChannelSchema.enum;
